module.exports = __webpack_public_path__ + "img/category-favorite-hover.0b873953.png";